import { render, staticRenderFns } from "./EmailLinkCompass.vue?vue&type=template&id=8b86fdb0&"
import script from "./EmailLinkCompass.vue?vue&type=script&lang=js&"
export * from "./EmailLinkCompass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports